<!--
 * @Description:  员工变更管理
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:32:28
--> 
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <mrc_ess_staffInfo
              v-model="list.staff_uuid"
              :dropDownList="dropDownList"
              job_post_name="job_post_uuid"
              job_grade_name="job_post_grade_uuid"
              client_name="client_uuid"
              org_level_name="org_level_uuid"
              org_level_all="org_level_uuid"
              dept_name="dept_uuid"
              :label="this.$t('label_Transfer_personnel') + '*'"
              @changeStaffList="changeList"
              :readonly="disabled"
              :disabled="Boolean($store.state.uuid)"
              :errorMessages="$errors('list', 'staff_uuid', requiredRule)"
            >
            </mrc_ess_staffInfo>
          </v-col>
          <v-col cols="12" sm="6">
            <!-- afterDate -->
            <mrc_ess_datePicker
              @getTime="paramsChange"
              :errMsg="
                $errors('list', 'movement_effective_utc_date', requiredRule)
              "
              :disabled="disabled"
              :label="this.$t('label_Effective_date') + '*'"
              v-model="list.movement_effective_utc_date"
            ></mrc_ess_datePicker>
          </v-col>
          <v-col cols="12" sm="6"> </v-col>
        </v-row>
        <v-card class="mb-4" flat outlined rounded="lg" v-if="list.staff_uuid">
          <!-- 新增的显示 -->
          <v-card-text>
            <v-row v-if="!$store.state.uuid">
              <v-col cols="12" sm="6">
                <mrc_ess_multiText
                  :label="$t('label_The_original_company')"
                  :placeholder="INT(viewList.org_level_uuid)"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="true"
                  :field="INT(viewList.org_level_uuid)"
                >
                </mrc_ess_multiText>
                <!-- <mrc_ess_prompt :label="this.$t('label_The_original_company')"
                                :rules='false'
                                :disabled='disabled'
                                :disabledTwo='true'
                                value_field='uuid'
                                view_fields='org_level_name'
                                :background-color="disabled?'':'#f5f5f5'"
                                :select_arr='$store.state.topcompanylist'
                                v-model="viewList.org_level_uuid_save_value">
                </mrc_ess_prompt> -->
              </v-col>
              <v-col cols="12" sm="6">
                <!-- <mrc_ess_prompt :label="$t('label_The_original_department')"
                                :rules='false'
                                :disabled='disabled'
                                :disabledTwo='true'
                                :background-color="disabled?'':'#f5f5f5'"
                                v-model="viewList.dept_uuid_save_value"
                                :obj="deptuuid">
                </mrc_ess_prompt> -->
                <mrc_ess_multiText
                  :label="$t('label_The_original_department')"
                  :field="INT(viewList.dept_uuid)"
                  :placeholder="INT(viewList.dept_uuid)"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="true"
                >
                </mrc_ess_multiText>
              </v-col>
              <v-col cols="12" sm="6">
                <!-- <mrc_ess_prompt :label="$t('label_The_original_position')"
                                :rules='false'
                                :disabled='disabled'
                                :disabledTwo='true'
                                :background-color="disabled?'':'#f5f5f5'"
                                v-model="viewList.job_post_uuid_save_value"
                                :obj="job_post_uuid">
                </mrc_ess_prompt> -->
                <mrc_ess_multiText
                  :label="$t('label_The_original_position')"
                  :field="INT(viewList.job_post_uuid)"
                  :placeholder="INT(viewList.job_post_uuid)"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="true"
                >
                </mrc_ess_multiText>
              </v-col>

              <v-col cols="12" sm="6">
                <!-- <mrc_ess_prompt :label="$t('label_original_staff_grade')"
                                :rules='false'
                                :disabled='disabled'
                                :disabledTwo='true'
                                :background-color="disabled?'':'#f5f5f5'"
                                v-model="viewList.staff_grade_save_value"
                                :obj="staffGrade">
                </mrc_ess_prompt> -->
                <mrc_ess_multiText
                  :label="$t('label_original_staff_grade')"
                  :field="INT(viewList.staff_grade)"
                  :placeholder="INT(viewList.staff_grade)"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="true"
                >
                </mrc_ess_multiText>
              </v-col>

              <v-col cols="12" sm="6">
                <!-- <mrc_ess_prompt :label="$t('label_original_staff_type')"
                                :rules='false'
                                :disabled='disabled'
                                :disabledTwo='true'
                                :background-color="disabled?'':'#f5f5f5'"
                                v-model="viewList.staff_type_save_value"
                                :obj="staffTypePro">
                </mrc_ess_prompt> -->
                <mrc_ess_multiText
                  :label="$t('label_original_staff_type')"
                  :placeholder="INT(viewList.staff_type)"
                  :field="INT(viewList.staff_type)"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="true"
                >
                </mrc_ess_multiText>
              </v-col>

              <v-col cols="12" sm="6">
                <!-- <mrc_ess_prompt :label="$t('label_Former_boss')"
                                :rules='false'
                                :placeholder="INT(viewList.direct_leader_code)"
                                :disabled='disabled'
                                :disabledTwo='true'
                                :background-color="disabled?'':'#f5f5f5'"
                                v-model="viewList.direct_leader_code_save_value"
                                :obj="superior">
                </mrc_ess_prompt> -->
                <mrc_ess_multiText
                  :label="$t('label_Former_boss')"
                  :field="INT(viewList.direct_leader_code)"
                  :placeholder="INT(viewList.direct_leader_code)"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="true"
                >
                </mrc_ess_multiText>
              </v-col>
              <v-col cols="12">
                <!-- <mrc_ess_prompt :label="$t('label_The_original_role')"
                                :rules='false'
                                :multiple="true"
                                str
                                :disabled='disabled'
                                :disabledTwo='true'
                                :background-color="disabled?'':'#f5f5f5'"
                                v-model="viewList.role_uuids_save_value"
                                :obj="spica">
                </mrc_ess_prompt> -->
                <mrc_ess_multiText
                  :label="$t('label_The_original_role')"
                  :field="INT(viewList.role_uuids)"
                  :placeholder="INT(viewList.role_uuids)"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="true"
                >
                </mrc_ess_multiText>
              </v-col>
              <v-col cols="12">
                <!-- <mrc_ess_prompt :label="$t('label_staffVariation_m_originalCostCenter')"
                                :rules='false'
                                :disabled='disabled'
                                :disabledTwo='true'
                                :background-color="disabled?'':'#f5f5f5'"
                                v-model="viewList.cost_center_uuid_save_value"
                                :obj="{'org_level_uuid':$store.state.currentCompany,'prompt_name':'cost_center'}">
                </mrc_ess_prompt> -->
                <mrc_ess_multiText
                  :label="$t('label_The_original_role')"
                  :placeholder="INT(viewList.cost_center)"
                  :field="INT(viewList.cost_center)"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="true"
                >
                </mrc_ess_multiText>
              </v-col>
              <v-col cols="12">
                <!-- <mrc_ess_prompt :label="$t('label_staffVariation_m_originalDay')"
                                :rules='false'
                                :disabled='disabled'
                                :disabledTwo='true'
                                :background-color="disabled?'':'#f5f5f5'"
                                v-model="viewList.holiday_group_uuid_save_value"
                                :obj="{'prompt_name':'ess_holiday_group_select'}">
                </mrc_ess_prompt> -->
                <mrc_ess_multiText
                  :label="$t('label_staffVariation_m_originalDay')"
                  :field="INT(viewList.holiday_group)"
                  :placeholder="INT(viewList.holiday_group)"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="true"
                >
                </mrc_ess_multiText>
              </v-col>
            </v-row>
            <!-- 修改的显示------------------------------- -->
            <v-row v-else>
              <v-col cols="12" sm="6">
                <mrc_ess_prompt
                  :label="this.$t('label_The_original_company')"
                  :rules="false"
                  :disabled="disabled"
                  :disabledTwo="true"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  value_field="uuid"
                  view_fields="org_level_name"
                  :select_arr="$store.state.topcompanylist"
                  v-model="list.original_org_level_uuid"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_prompt
                  :label="this.$t('label_The_original_department')"
                  :rules="false"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="disabled"
                  :disabledTwo="true"
                  v-model="list.original_staff_dept_uuid"
                  :obj="updatedeptuuid"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_prompt
                  :label="this.$t('label_The_original_position')"
                  :rules="false"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="disabled"
                  :disabledTwo="true"
                  v-model="list.original_staff_post_uuid"
                  :obj="updatejob_post_uuid"
                >
                </mrc_ess_prompt>
              </v-col>

              <v-col cols="12" sm="6">
                <mrc_ess_prompt
                  :label="this.$t('label_original_staff_grade')"
                  :rules="false"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="disabled"
                  :disabledTwo="true"
                  v-model="list.original_staff_grade"
                  :obj="staffGrade"
                >
                </mrc_ess_prompt>
              </v-col>

              <v-col cols="12" sm="6">
                <mrc_ess_prompt
                  :label="this.$t('label_original_staff_type')"
                  :rules="false"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="disabled"
                  :disabledTwo="true"
                  v-model="list.original_staff_type"
                  :obj="staffTypePro"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_prompt
                  :label="this.$t('label_Former_boss')"
                  :rules="false"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="disabled"
                  :disabledTwo="true"
                  v-model="list.original_leader_uuid"
                  :obj="updatesuperior"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12">
                <mrc_ess_prompt
                  :label="this.$t('label_The_original_role')"
                  :rules="false"
                  :multiple="true"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  str
                  :disabled="disabled"
                  :disabledTwo="true"
                  v-model="list.original_role_uuid"
                  :obj="updatespica"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12">
                <mrc_ess_prompt
                  :label="$t('label_staffVariation_m_originalCostCenter')"
                  :rules="false"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  :disabled="disabled"
                  :disabledTwo="true"
                  v-model="list.original_cost_center_uuid"
                  :obj="{
                    org_level_uuid: $store.state.currentCompany,
                    prompt_name: 'cost_center',
                  }"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12">
                <mrc_ess_prompt
                  :label="$t('label_staffVariation_m_originalDay')"
                  :rules="false"
                  :disabled="disabled"
                  :disabledTwo="true"
                  :background-color="disabled ? '' : '#f5f5f5'"
                  v-model="list.origin_holiday_group_uuid"
                  :obj="{ prompt_name: 'ess_holiday_group_select' }"
                >
                </mrc_ess_prompt>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card flat outlined rounded="lg">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <mrc_ess_autoComplete
                  :label="$t('label_New_company') + '*'"
                  orgView
                  :readonly="disabled"
                  :errorMessages="
                    $errors('list', 'transferred_org_level_uuid', requiredRule)
                  "
                  :prompt_name="new_orguuid"
                  v-model="list.transferred_org_level_uuid"
                >
                </mrc_ess_autoComplete>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_autoComplete
                  :label="$t('label_New_department') + '*'"
                  :readonly="disabled"
                  :errorMessages="
                    $errors('list', 'transferred_staff_dept_uuid', requiredRule)
                  "
                  deptView
                  v-model="list.transferred_staff_dept_uuid"
                  :prompt_name="newdeptuuid"
                >
                </mrc_ess_autoComplete>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_autoComplete
                  :label="$t('label_New_position') + '*'"
                  :readonly="disabled"
                  positionView
                  :errorMessages="
                    $errors('list', 'transferred_staff_post_uuid', requiredRule)
                  "
                  v-model="list.transferred_staff_post_uuid"
                  :prompt_name="newjob_post_uuid"
                >
                </mrc_ess_autoComplete>
              </v-col>
              <v-col cols="12" sm="6">
                <!-- <mrc_ess_autoComplete :label="$t('label_new_job_level') + '*'"
                                      :readonly="disabled"
                                      postGradesView
                                      :errorMessages="$errors('list','transferred_staff_grade_uuid',requiredRule)"
                                      v-model="list.transferred_staff_grade_uuid"
                                      :prompt_name="newmrbase_sys_job_post_grades">
                </mrc_ess_autoComplete> -->
                <mrc_ess_autoComplete
                  :label="$t('label_new_staff_grade') + '*'"
                  :readonly="disabled"
                  :errorMessages="
                    $errors('list', 'transferred_staff_grade', requiredRule)
                  "
                  v-model="list.transferred_staff_grade"
                  :prompt_name="newstaffGrade"
                >
                </mrc_ess_autoComplete>
              </v-col>

              <v-col cols="12" sm="6">
                <mrc_ess_prompt
                  :label="this.$t('label_new_staff_type') + '*'"
                  :rules="false"
                  :errMsg="
                    $errors('list', 'transferred_staff_type', requiredRule)
                  "
                  :disabled="disabled"
                  v-model="list.transferred_staff_type"
                  :obj="newstaffTypePro"
                >
                </mrc_ess_prompt>
              </v-col>

              <v-col cols="12" sm="6">
                <!-- :errMsg="$errors('list','transferred_leader_uuid',requiredRule)" -->
                <mrc_ess_prompt
                  :label="this.$t('label_New_boss')"
                  :rules="false"
                  :disabled="disabled"
                  v-model="list.transferred_leader_uuid"
                  :obj="newsuperior"
                >
                </mrc_ess_prompt>
              </v-col>

              <v-col cols="12">
                <mrc_ess_prompt
                  :label="this.$t('label_The_new_role') + '*'"
                  :rules="false"
                  :multiple="true"
                  :disabled="disabled"
                  str
                  :errMsg="
                    $errors('list', 'transferred_role_uuid', requiredRule)
                  "
                  v-model="list.transferred_role_uuid"
                  :obj="newspica"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12">
                <!-- :errMsg="$errors('list','cost_center_uuid',requiredRule)" -->
                <mrc_ess_prompt
                  :label="$t('label_staffVariation_m_newCostCenter')"
                  :rules="false"
                  :disabled="disabled"
                  v-model="list.transferred_cost_center_uuid"
                  :obj="{
                    org_level_uuid: list.transferred_org_level_uuid,
                    prompt_name: 'cost_center',
                  }"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col cols="12">
                <mrc_ess_prompt
                  :label="$t('label_staffVariation_m_newDay')"
                  :rules="false"
                  :disabled="disabled"
                  v-model="list.transferred_holiday_group_uuid"
                  :obj="{ prompt_name: 'ess_holiday_group_select' }"
                >
                </mrc_ess_prompt>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-row>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="this.$t('label_note')"
              noRequired
              :error-messages="$errors('list', 'remark', nocharacter)"
              :isNational="judegNational('remark')"
              v-model="list.remark"
              :readonly="disabled"
            >
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn
        @success="success"
        @cancel="cancel"
        :loading="btnIsLoading"
        v-if="!disabled"
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getStaffVariationList,
  detailStaffVariation,
  addStaffVariation,
  updateStaffVariation,
  deleteStaffVariation,
  getallList,
  fintStaffInfo,
} from "@/service/api/staffmsg.js";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
import Item from "../../../components/treeList/Item.vue";
export default {
  components: { Item },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropDownList: [],
      skeletonloading: true,
      list: {},
      btnIsLoading: false,
      viewList: {},
      viewListUuid: {},
    };
  },
  computed: {
    // // staffText: [this.$t('label_Former_boss') + '*', ''],
    // company_uuid () { //当前选中公司
    //   // return this.$store.state.currentCompany
    //   return this.viewList.org_level_uuid_save_value
    // },
    // deptuuid () {  //部门参照查询字段
    //   return { prompt_name: 'levelUuid_deptUuid', org_level_uuid: this.company_uuid }
    // },
    // company_Name () { //当前选中公司名字
    //   const items = this.$store.state.topcompanylist.filter(item => item.uuid == this.$store.state.currentCompany)
    //   return items[0].org_level_name
    // },
    // staffGrade () { //员工等级参照
    //   return {
    //     prompt_name: 'staff_grade',
    //     org_level_uuid: this.company_uuid,
    //   }
    // },
    // staffTypePro () {//员工类型
    //   return {
    //     prompt_name: 'staff_type',
    //     org_level_uuid: this.company_uuid,
    //   }
    // },
    // job_post_uuid () {  //岗位查询
    //   return { prompt_name: 'level-dept-post', dept_uuid: this.viewList.dept_uuid_save_value }
    // },
    // superior () { //上司高级参照
    //   return { prompt_name: 'boss', org_level_uuid: this.company_uuid, staff_uuid: this.list.staff_uuid }
    // },
    // spica () { //角色高级参照
    //   return { prompt_name: 'level-role', org_level_uuid: this.company_uuid }
    // },
    new_orguuid() {
      return {
        prompt_name: "manager-sub-company",
        org_level_uuid: this.$store.state.currentCompany,
      };
    },
    newdeptuuid() {
      //部门参照查询字段
      return {
        prompt_name: "levelUuid_deptUuid",
        org_level_uuid: this.list.transferred_org_level_uuid,
      };
    },
    newjob_post_uuid() {
      //岗位查询
      return {
        prompt_name: "level-dept-post",
        dept_uuid: this.list.transferred_staff_dept_uuid,
      };
    },
    newstaffGrade() {
      //员工等级参照
      return {
        prompt_name: "staff_grade",
        org_level_uuid: this.list.transferred_org_level_uuid,
      };
    },
    newsuperior() {
      //上司高级参照
      return {
        prompt_name: "new_boss",
        org_level_uuid: this.list.transferred_org_level_uuid,
      };
    },
    newspica() {
      //角色高级参照
      return {
        prompt_name: "level-role",
        org_level_uuid: this.list.transferred_org_level_uuid,
      };
    },
    newstaffTypePro() {
      //新员工类型
      return {
        prompt_name: "staff_type",
        org_level_uuid: this.list.transferred_org_level_uuid,
      };
    },
    newmrbase_sys_job_post_grades() {
      //岗位等级
      return {
        prompt_name: "mrbase_sys_job_post_grades",
        job_post_uuid: this.list.transferred_staff_post_uuid,
      };
    },
    updatedeptuuid() {
      //部门参照查询字段
      return {
        prompt_name: "levelUuid_deptUuid",
        org_level_uuid: this.list.original_staff_dept_uuid,
      };
    },
    updatejob_post_uuid() {
      //岗位查询
      return {
        prompt_name: "level-dept-post",
        dept_uuid: this.list.original_staff_dept_uuid,
      };
    },
    updatesuperior() {
      //上司高级参照
      return {
        prompt_name: "new_boss",
        org_level_uuid: this.list.original_org_level_uuid,
      };
    },
    updatespica() {
      //角色高级参照
      return {
        prompt_name: "level-role",
        org_level_uuid: this.list.original_org_level_uuid,
      };
    },
    updatemrbase_sys_job_post_grades() {
      //岗位等级
      return {
        prompt_name: "mrbase_sys_job_post_grades",
        job_post_uuid: this.list.original_staff_post_uuid,
      };
    },
  },
  created() {},
  watch: {},
  async mounted() {
    this.national("mrbase_sys_staff_movement");
    if (this.$store.state.uuid) {
      await this.getDetail();
      getallList({
        org_level_uuid: this.$store.state.currentCompany,
        filter: "StaffChange-update&" + this.list.staff_uuid,
      }).then((res) => {
        if (res.code == 200) {
          this.dropDownList = res.data;
        }
      });
    } else {
      getallList({
        org_level_uuid: this.$store.state.currentCompany,
        filter: "StaffChange-add",
      }).then((res) => {
        if (res.code == 200) {
          this.dropDownList = res.data;
        }
      });
    }
  },
  methods: {
    paramsChange() {},
    changeList(val) {
      if (this.$store.state.uuid) {
      } else {
        this.viewList = val;
        fintStaffInfo({ staff_uuid: val.uuid }).then((res) => {
          if (res.code == 200) {
            this.viewListUuid = res.data;
          }
        });
      }
    },
    async getDetail() {
      this.skeletonloading = true;
      const res = await detailStaffVariation({ uuid: this.$store.state.uuid });
      if (res.code == 200) {
        this.list = this.$clone(res.data);
        this.viewList = this.$clone(res.data);
      } else {
      }
      this.skeletonloading = false;
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      this.btnIsLoading = true;
      delete this.list.result_status;
      let obj = {}; //新增要用的数据
      obj.original_org_level_uuid = this.changeString(
        this.viewList.org_level_uuid_save_valu
      );
      obj.original_staff_dept_uuid = this.changeString(
        this.viewList.dept_uuid_save_valu
      );
      obj.original_staff_post_uuid = this.changeString(
        this.viewList.job_post_uuid_save_valu
      );
      obj.original_leader_uuid = this.changeString(
        this.viewList.direct_leader_code
      );
      obj.original_role_uuid = this.changeString(
        this.viewList.role_uuids_save_valu
      );
      obj.original_cost_center_uuid = this.changeString(
        this.viewList.cost_center_uuid_save_valu
      );
      obj.original_staff_grade_uuid = this.changeString(
        this.viewList.job_post_grade_uuid_save_valu
      );
      // obj.original_staff_grade_uuid = this.changeString(this.viewList.job_post_grade_uuid_save_valu)
      // obj.original_staff_grade_uuid = this.changeString(this.viewList.job_post_grade_uuid_save_valu)

      if (this.$store.state.uuid) {
        updateStaffVariation({ ...this.$deletefield(null, this.list) }).then(
          (res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              });
              this.getDetail();
              this.$emit("changeReadonly");
            }
            this.btnIsLoading = false;
          }
        );
      } else {
        addStaffVariation({ ...this.list, ...obj }).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t("message_added_successfully") });
            this.$router.push({ name: "staffVariation" });
          }
          this.btnIsLoading = false;
        });
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "staffVariation",
            });
          })
          .catch((err) => {});
      }
    },
    changeString(arr) {
      if (!arr) return "";
      return arr;
      // if (!Array.isArray(arr)) return arr
      // return arr = arr.join()
    },
  },
  validations: {
    list: {
      staff_uuid: {
        required,
      },
      movement_effective_utc_date: {
        required,
      },
      cost_center_uuid: {
        // required
      },
      transferred_leader_uuid: {
        // required
      },
      transferred_org_level_uuid: {
        required,
      },
      transferred_staff_dept_uuid: {
        required,
      },
      transferred_staff_post_uuid: {
        required,
      },
      transferred_staff_grade: {
        required,
      },
      // transferred_staff_grade_uuid: {
      //   required
      // },
      transferred_role_uuid: {
        required,
      },
      transferred_staff_type: {
        required,
      },
      remark: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
    },
  },
};
</script>

<style scoped>
</style>

